import React from 'react';
import styled from 'styled-components';
import { Body5, Body7, Container } from '@ui';
import { CollapseButton } from '@ui/buttons';
import { MicroLabel, PassiveCard, ReadOnlyJson } from '@features/scoreSpec/styles';

// What the form changed that the user did not ask for.
//
// The rewrites are not optional — every spec in the store is written in a shape create rejects, so
// a form that did not make them would fail on every source. But a `format_prompt` that silently
// vanishes is a form the user stops trusting the first time they notice, and they will notice. So
// each rewrite is named, in words, next to the body it produced.

const Item = styled.li`
  margin: 0 0 6px 0;
  &:last-child {
    margin-bottom: 0;
  }
`;

const List = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: ${({ theme }) => theme.themeColors.secondaryText};
  font-size: 12.5px;
  line-height: 1.55;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const RewritesPanel = ({ changes, spec }) => {
  const [isCollapsed, setCollapsed] = React.useState(true);

  return (
    <PassiveCard aria-label="What this form rewrote">
      <MicroLabel>What this form rewrote for you</MicroLabel>
      <Container top={8}>
        {changes.length === 0 ? (
          <Body7 isLowContrast>Nothing beyond your edits — this spec is already in the shape create accepts.</Body7>
        ) : (
          <List>
            {changes.map((change) => (
              <Item key={change}>{change}</Item>
            ))}
          </List>
        )}
      </Container>

      <Container top={16}>
        <Header>
          <Body5 bold>The request body</Body5>
          <CollapseButton isCollapsed={isCollapsed} setCollapsed={setCollapsed} />
        </Header>
        {!isCollapsed && (
          <Container top={8}>
            <ReadOnlyJson>{JSON.stringify(spec, null, 2)}</ReadOnlyJson>
          </Container>
        )}
      </Container>
    </PassiveCard>
  );
};
